import { useLayoutEffectWithRef } from 'hooks/useLayoutEffectWithRef';
import { useCallback } from 'react';

export function useScrollIntoView<THtmlElt extends HTMLElement>(enabled: boolean, options: ScrollIntoViewOptions) {
  const doScrollIntoView = useCallback(
    (currentRef: THtmlElt) => {
      if (enabled) {
        currentRef.scrollIntoView(options);
      }
    },
    [enabled, options],
  );
  return useLayoutEffectWithRef(doScrollIntoView);
}
